module.exports = __webpack_public_path__ + "img/leadershipOffice.d16ff840.png";